<template>
    <div>
        <div style="min-height: 60vh;" class="card d-flex">
            <div class="card-body">
                <b-button @click="$router.back()">
                    <i class="fas fa-arrow-left me-1"></i>
                    Documents
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data:() => ({}),
    computed:{},
    methods:{},
    mounted(){},
}
</script>

<style>

</style>